import { Component, Input } from '@angular/core';
import { BlogContent } from '@app/@shared/models/search/cti-search.model';

@Component({
    selector: 'app-blog-card',
    templateUrl: './blog-card.component.html',
    styleUrls: ['./blog-card.component.scss'],
    standalone: false
})
export class BlogCardComponent {

  @Input() blog: BlogContent = {
    id: null,
    name: 'Missing blog info',
    description: '',
    completionDate: null,
    author: '',
    authorAvatar: '',
    entitled: false,
  } as BlogContent;
  @Input() consistentHeight = false;

}
